module.exports = __webpack_public_path__ + "4ece24135c932fb947e9e20961883676.png";